/**
 * Get previous slide index
 */
export const getPreviousSlideIndex = (currentIndex, items) => {
	return currentIndex === 0 ? items.length - 1 : currentIndex - 1;
};
